export function RouteLoadingPage() {
  return (
    <main className="flex h-full min-h-0 items-center justify-center p-6" aria-live="polite">
      <p className="text-muted-foreground text-xs">Loading administration…</p>
    </main>
  );
}
